/**
 * Employee Bank Details Tab Component
 * 
 * This component is extracted from EmployeeForm.jsx for modularity.
 * It maintains the exact same structure and data-testid attributes.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const BankDetailsTab = ({ formData, handleChange }) => {
  return (
    <Card className="border-border/60">
      <CardHeader>
        <CardTitle className="font-heading">Bankverbindung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label htmlFor="iban">IBAN</Label>
            <Input
              id="iban"
              value={formData.iban || ''}
              onChange={(e) => handleChange('iban', e.target.value)}
              placeholder="DE89 3704 0044 0532 0130 00"
              data-testid="employee-iban"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="bic">BIC</Label>
            <Input
              id="bic"
              value={formData.bic || ''}
              onChange={(e) => handleChange('bic', e.target.value)}
              data-testid="employee-bic"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="bank_name">Bank</Label>
            <Input
              id="bank_name"
              value={formData.bank_name || ''}
              onChange={(e) => handleChange('bank_name', e.target.value)}
              data-testid="employee-bank"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BankDetailsTab;
